(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('p2Settings', {
        templateUrl: 'views/components/views/p2Settings/p2Settings.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['stateService', 'p2SettingsService', 'layoutService', function (stateService, p2SettingsService, layoutService) {

    		// #region VARIABLES & DEFINITIONS

            const vm = this;
            let tabletSize = layoutService.getMediaQueries().tablet;
            
            vm.model = {
                tabletSize: tabletSize,
                itemState: '',
                p2SettingKeyno: '',
                filterValueButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.filterValue = '' }
                ],
                filterValue: '',
                itemsListSettings: []
            };
            
    		// #endregion VARIABLES & DEFINITIONS

    		// #region LOAD PROCEDURE CALLS

            let loadP2Settings = function () {
                p2SettingsService.listP2Settings().then(function (list) {
                    angular.copy(list, vm.model.itemsListSettings);

                    angular.forEach(vm.model.itemsListSettings, function (item) {
                        if (item.item_state > '') {
                            vm.model.itemState = item.item_state;
                        }
                    });
                });
            };
            
    		// #endregion LOAD PROCEDURE CALLS

            // #region UPDATE PROCEDURE LIST FUNCTION

            vm.updateList = function () {
                loadP2Settings();
            };

            // #endregion UPDATE PROCEDURE LIST FUNCTION

            // #region LIST DIRECTION BUTTON FUNCTION

            vm.openEdit = function (item) {
                vm.model.p2SettingKeyno = item.item_id;
            };

            // #endregion LIST DIRECTION BUTTON FUNCTION

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                let go = function (parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                };

                switch (state) {
                    case 'p2settingedit':
                        if (tabletSize.matches === true && vm.model.itemState === 'p2settingedit') {
                            vm.model.p2SettingKeyno = '0';
                        } else {
                            go({ p2_setting_keyno: '0' });
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = function () {
                loadP2Settings();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
